import { Component, ComponentRef, Type, ViewContainerRef } from '@angular/core';
import { StringWhitespaceOrEmptyComponent } from '../../default/string-whitespace-or-empty/string-whitespace-or-empty.component';
import { StringComponent } from '../../default/string/string.component';
import { StringOrEmptyComponent } from '../../default/string-or-empty/string-or-empty.component';
import { StringOrDefaultComponent } from '../../default/string-or-default/string-or-default.component';
import { BooleanComponent } from '../../default/boolean/boolean.component';
import { StatusComponent } from '../../default/status/status.component';
import { DatetimeComponent } from '../../default/datetime/datetime.component';
import { MoneyComponent } from '../../default/money/money.component';
import { CurrencyComponent } from '../../default/currency/currency.component';
import { CountryComponent } from '../../default/country/country.component';
import { CountriesComponent } from '../../default/countries/countries.component';
import { LanguageComponent } from '../../default/language/language.component';
import { StringWhitespaceOrEmptyWithCopyComponent } from '../../default/string-whitespace-or-empty-with-copy/string-whitespace-or-empty-with-copy.component';
import { InvoiceStatusComponent } from '../../default/invoice-status/invoice-status.component';
import { FinanceInvoiceStatusComponent } from '../../default/finance-invoice-status/finance-invoice-status.component';
import { FinancePaymentStatusComponent } from '../../default/finance-payment-status/finance-payment-status.component';
import { EarningStatusComponent } from '../../default/earning-status/earning-status.component';
import { PaymentMethodStatusComponent } from '../../default/payment-method-status/payment-method-status.component';
import { LinkComponent } from '../../default/link/link.component';
import { RbacPermissionsConstant } from '../../../../services/rbac/rbac-permissions.constant';
import { LinksComponent } from '../../default/links/links.component';
import { AttachmentsComponent } from '../../special/attachments/attachments.component';
import { AffiliatesTrackersTypeComponent } from '../../special/affiliates-trackers-type/affiliates-trackers-type.component';
import { AffiliatePdfComponent } from '../../special/affiliate-pdf/affiliate-pdf.component';
import { GetSmartLinkComponent } from '../../special/get-smart-link/get-smart-link.component';
import { GoalRevenueTypeComponent } from '../../special/goal-revenue-type/goal-revenue-type.component';
import { GoalPayoutTypeComponent } from '../../special/goal-payout-type/goal-payout-type.component';
import { NumberComponent } from '../../default/number/number.component';
import { NumberStatusComponent } from '../../default/number-status/number-status.component';
import { PayoutModelComponent } from '../../special/payout-model/payout-model.component';
import { BusinessFormatComponent } from '../../special/business-format/business-format.component';
import { ImagePreviewComponent } from '../../special/image-preview/image-preview.component';
import { CellWithLabelComponent } from '../../special/cell-with-label/cell-with-label.component';
import { ProtectedFieldComponent } from '../../default/protected/protected.component';
import { CountryShortComponent } from '../../default/country-short/country-short.component';
import { RegionComponent } from '../../default/region/region.component';
import { MoneyWithCurrencyComponent } from '../../special/money-with-currency/money-with-currency.component';
import { ComparingAnalyticsDifferenceTypeComponent } from '../../special/comparing-analytics-difference-type/comparing-analytics-difference-type.component';
import { ComparingNumberComponent } from '../../special/comparing-number/comparing-number.component';
import { ComparingPercentageComponent } from '../../special/comparing-percentage/comparing-percentage.component';
import { TABLE_TRANSLATIONS } from '../../../facade/table-facade/table-translation.const';

const components: Record<string, Type<any> | IComponent> = {
  'gtd-ui-field-default-string': StringComponent,
  string_or_empty: StringOrEmptyComponent,
  string_or_default: StringOrDefaultComponent,
  'gtd-ui-field-default-boolean': BooleanComponent,
  'gtd-ui-field-user-status': StatusComponent,
  'gtd-ui-field-default-datetime': DatetimeComponent,
  'gtd-ui-field-default-money': {
    component: MoneyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('customClass', 'w100 d-flex justify-content-end');
    },
  },
  'gtd-ui-field-default-currency': CurrencyComponent,
  'gtd-ui-field-default-country': {
    component: CountryComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('length', 30);
    },
  },
  countries: CountriesComponent,
  language: LanguageComponent,
  country_or_empty: {
    component: CountryComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('length', 30);
      setInputFn('nullIsEmpty', true);
    },
  },
  'gtd-ui-field-default-whitespace-or-empty': StringWhitespaceOrEmptyComponent,
  string_whitespace_or_empty_with_copy: StringWhitespaceOrEmptyWithCopyComponent,
  'gtd-invoice-status': InvoiceStatusComponent,
  finance_invoice_status: FinanceInvoiceStatusComponent,
  finance_payment_status: FinancePaymentStatusComponent,
  finance_earning_status: EarningStatusComponent,
  payment_method_status: PaymentMethodStatusComponent,
  offer_by_advertiser: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/offers', data.data?.offer_id]);
      setInputFn(
        'displayData',
        data.data?.offer_name +
          ' ' +
          (data.data?.advertiser_name ? $localize`:@@offer.by_advertiser:By Advertiser` + ' ' + data.data?.advertiser_name : '')
      );
      setInputFn('relationData', data.data?.id);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_OFFER_PROFILE);
    },
  },
  advertiser_brands_link: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', null);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
      setInputFn('rbacProperty', null);
    },
  },
  offer: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/offers', data.data?.id]);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_OFFER_PROFILE);
    },
  },
  many_offers: {
    component: LinksComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', '/app/offers');
      setInputFn('data', data.data);
      setInputFn('title', $localize`:@@offer.all:All Offers`);
      setInputFn('rbac', RbacPermissionsConstant.WIDGETS_GOAL_PROFILE);
    },
  },
  goal: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/goal', data.data?.id]);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_SINGLE_OFFER);
    },
  },
  affiliate_tracker_id: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/affiliate-trackers', data.data]);
      setInputFn('displayData', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_AFFILIATE_TRACKERS_PROFILE);
    },
  },
  click_id: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/clicks', data.data]);
      setInputFn('displayData', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_CLICK_PROFILE);
    },
  },
  invoice_id: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/billing/invoices', data.data]);
      setInputFn('displayData', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_CLICK_PROFILE);
    },
  },
  smart_link_id: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/smart-links', data.data]);
      setInputFn('displayData', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_SMART_LINK_PROFILE);
    },
  },
  conversion_id: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/conversions', data.data]);
      setInputFn('displayData', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_CONVERSIONS);
    },
  },
  global_postback_id: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/affiliate-trackers/global', data.data]);
      setInputFn('displayData', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_CONVERSIONS);
    },
  },
  finance_earning_id: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/billing/finance-earnings', data.data]);
      setInputFn('displayData', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_EARNINGS);
    },
  },
  finance_invoice_id: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/billing/finance-invoices', data.data]);
      setInputFn('displayData', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_INVOICES);
    },
  },
  finance_payment_id: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/billing/finance-payments', data.data]);
      setInputFn('displayData', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_PAYMENTS);
    },
  },
  finance_earning: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/billing/finance-earnings', data.data?.id]);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_EARNINGS);
    },
  },
  finance_invoice: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/billing/finance-invoices', data.data?.id]);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_INVOICES);
    },
  },
  attachments: AttachmentsComponent,
  affiliates_trackers_type: AffiliatesTrackersTypeComponent,
  'gtd-affiliate-pdf': AffiliatePdfComponent,
  get_link: GetSmartLinkComponent,
  revenue_type: GoalRevenueTypeComponent,
  payout_type: GoalPayoutTypeComponent,
  offer_url_source: {
    component: StringWhitespaceOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data?.source || 'UNK');
    },
  },
  goal_type: {
    component: StringWhitespaceOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data?.name);
    },
  },
  date: DatetimeComponent,
  email: StringWhitespaceOrEmptyComponent,
  text: StringWhitespaceOrEmptyComponent,
  string: StringWhitespaceOrEmptyComponent,
  string_justify_end: {
    component: StringWhitespaceOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('customClass', 'd-flex justify-content-end mr-10');
    },
  },
  boolean: BooleanComponent,
  number: NumberComponent,
  postback_status: NumberStatusComponent,
  user_status: StatusComponent,
  datetime: DatetimeComponent,
  money: {
    component: MoneyWithCurrencyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
    },
  },
  currency: CurrencyComponent,
  country: {
    component: CountryComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('length', 30);
    },
  },
  counties: CountriesComponent,
  invoice_status: InvoiceStatusComponent,
  payout_model: {
    component: StringWhitespaceOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data?.name && data.data?.name + ' (' + data.data?.short_name + ') / ' + data.data?.id);
    },
  },
  revenue_model: {
    component: StringWhitespaceOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data?.name && data.data?.name + ' (' + data.data?.short_name + ') / ' + data.data?.id);
    },
  },
  payout_model_id: PayoutModelComponent,
  business_model: BusinessFormatComponent,
  preview_url: {
    component: ImagePreviewComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('url', data.data);
      setInputFn('row', data.row);
    },
  },
  string_with_label: {
    component: CellWithLabelComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('label', data.label);
      setInputFn('data', data.data);
      setInputFn('type', 'string_with_label');
    },
  },
  conversion_tracking_type: {
    component: CellWithLabelComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('label', data.label);
      setInputFn('url', data.data);
      setInputFn('type', 'conversion_tracking_type');
    },
  },
  os_with_label: {
    component: CellWithLabelComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('label', data.label);
      setInputFn('url', data.data);
      setInputFn('type', 'os_with_label');
    },
  },
  type_protected: ProtectedFieldComponent,
  country_short: CountryShortComponent,
  region: {
    component: RegionComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('countryCode', data.row?.country_code);
      setInputFn('regionCode', data.row?.region_code);
    },
  },
  money_with_currency: {
    component: MoneyWithCurrencyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
    },
  },
  comparing_analytics_difference: ComparingAnalyticsDifferenceTypeComponent,
  comparing_number: {
    component: ComparingNumberComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('customClass', 'w100 d-flex justify-content-end');
    },
  },
  comparing_percentage: {
    component: ComparingPercentageComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('customClass', 'w100 d-flex justify-content-end');
    },
  },
  click_hash: {
    component: StringWhitespaceOrEmptyWithCopyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('length', 32);
      setInputFn('fullWidth', true);
      setInputFn('customClass', 'd-flex');
    },
  },
  translatable_string: {
    component: StringOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', TABLE_TRANSLATIONS[data.data] ?? data.data);
    },
  },
  'conversion-tracking': {
    component: StringOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', TABLE_TRANSLATIONS[data.data] ?? data.data);
    },
  },
};

export class ComponentFactory {
  public static create = (container: ViewContainerRef, data: IData): void => {
    const componentData = components[data.type] || StringWhitespaceOrEmptyComponent;
    if ('component' in componentData) {
      const ref = container.createComponent(componentData.component);
      componentData.setInputs(data, ref.setInput.bind(ref));
    } else {
      const ref = container.createComponent(componentData);
      ref.setInput('data', data.data);
    }
  };
}

interface IComponent {
  component: Type<any>;
  setInputs: (data: IData, fn: ComponentRef<Component>['setInput']) => void;
}

interface IData {
  type: string;
  data: any;
  label: string;
  row: Record<string, any>;
  source: string;
}
